/*
  Srovnávač LED 2 - výsledky: verdikt, tabulka, graf a celý projekt.
  Volá se ze srovnavac.js s objektem S, který nese data a pomocné funkce.
  vcetneVysledku = false: jen karta naší nabídky (při změně zadání), výsledky se
  přepočítají až po kliknutí na KALKULACE.
*/

export function spocitejVysledky(S, vcetneVysledku = true) {
const { koren, N, $, fmt, num, hodnota, nazevVase, naM2, cenyProduktu, zvolenyStupen, roky, stupne, specRadek, ksVlastni, ksDleSpec, rozdil } = S;
  const z = { ks: num($("z_ks").value) };
  (N.vlastnosti||[]).forEach(v => z[v.klic] = num($("z_"+v.klic).value));
  const VN = nazevVase();
  N.parametry.forEach(par => z[par.klic] = num($("z_"+par.klic).value));
  const zm = {}; N.parametry.forEach(par => zm[par.klic] = z[par.klic] * z.ks);

  const h = $("v_hloubka").value;
  const prod = N.produkty.find(p => p.id === $("v_produkt").value);
  const bal = zvolenyStupen();
  const om = prod ? naM2(prod, h, bal) : null;
  if(!prod || !om) return;
  const hod = cenyProduktu(prod, bal);
  const o = { ks: om.ks }; N.parametry.forEach(par => o[par.klic] = hodnota(hod[par.klic]));

  $("naseNazev").textContent = prod.nazev;
  const zarN = hodnota((prod.vlastnosti||{}).zaruka);
  const stit = `<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5l-8-3Z"/><path d="m8.5 12 2.5 2.5 4.5-5"/></svg>`;
  $("odznaky").innerHTML =
    (prod.venkovni ? `<div class="odznak venku"><div><b>EXTERIÉR · OUTDOOR</b><small>Venkovní modul se silikonovou ochranou - srovnávejte jen s venkovními LED.</small></div></div>` : "") +
    (Number.isFinite(zarN) ? `<div class="odznak zaruka">${stit}<div><b>Záruka ${roky(zarN)}</b><small>na všechny 24V LEDBARy</small></div></div>` : "");
  koren.querySelector(".karta.nase").classList.toggle("outdoor", !!prod.venkovni);
  const zk = $("z_kryti")?.value || "";
  const var_ = $("varovani");
  if(zk && prod.kryti && zk !== prod.kryti){
    const zNaz = (N.kryti.find(k => k.hodnota === zk)||{}).nazev || zk, oNaz = (N.kryti.find(k => k.hodnota === prod.kryti)||{}).nazev || prod.kryti;
    var_.innerHTML = `Pozor: srovnáváte různé moduly - vaše LED jsou <b>${zNaz}</b>, vybraný LEDBAR je <b>${oNaz}</b>. Pro férové srovnání vyberte vpravo variantu pro stejné použití.`;
    var_.hidden = false;
  } else var_.hidden = true;
  $("pevne").innerHTML = N.parametry.map(par => `<div><dt>${par.nazev} za 1 ${N.kus}</dt><dd>${Number.isFinite(o[par.klic]) ? fmt(o[par.klic], par.des)+" "+par.jednotka : '<span class="chybi">doplníme</span>'}</dd></div>`).join("")
    + (N.vlastnosti||[]).map(v => `<div><dt>${v.nazev}</dt><dd>${fmt(hodnota((prod.vlastnosti||{})[v.klic]), v.des)} ${v.jednotka}</dd></div>`).join("")
    ;
  { const r = specRadek(), vl = ksVlastni();
    $("ksPozn").innerHTML = r ? (vl !== null && vl !== r.ks
      ? `Upraveno. Podle specifikace ${r.ks} ${N.kus}${r.poznamka ? ", "+r.poznamka : ""} - <a href="#" id="ksZpet">vrátit</a>`
      : `Podle specifikace${r.poznamka ? " ("+r.poznamka+")" : ""}. Můžete upravit podle potřeby.`) : "";
    $("ksZpet")?.addEventListener("click", e => { e.preventDefault(); ksDleSpec(); S.oznacZmenu(); spocitejVysledky(S, false); }); }

  /* plocha z rozměru rámu - počítá se vždy, i před KALKULACÍ (zobrazuje se nad zadáním) */
  const rSirka = num($("r_sirka")?.value), rVyska = num($("r_vyska")?.value), rPocet = num($("r_pocet")?.value);
  const platnyRozmer = Number.isFinite(rSirka) && rSirka > 0 && Number.isFinite(rVyska) && rVyska > 0 && Number.isInteger(rPocet) && rPocet > 0;
  const plochaRamu = platnyRozmer ? rSirka*rVyska/1e6 : NaN;
  const A = platnyRozmer ? plochaRamu*rPocet : NaN;
  $("ramPlocha").innerHTML = Number.isFinite(A)
    ? `1 rám ${fmt(rSirka)} × ${fmt(rVyska)} mm = <b>${fmt(plochaRamu,2)} m²</b> · celkem <b>${fmt(A,2)} m²</b>`
    : `Zadejte kladnou šířku, výšku a celý počet rámů.`;

  if(!vcetneVysledku) return;
  $("thVase").textContent = VN;
  $("thNase").textContent = prod.nazev + (prod.nakup && stupne(prod)[bal]?.ks ? ` · nákup ${fmt(stupne(prod)[bal].ks)} ${N.kus}` : "");

  /* tabulka */
  const radky = [{nazev:"Počet kusů", popis:"", vase:z.ks, nase:om.ks, jednotka:N.kus, lepsi:"nizsi", des:0}];
  const r0 = specRadek(), podleSpec = !!r0 && (ksVlastni() ?? r0.ks) >= r0.ks;
  const klicSvetla = (N.provoz||{}).klicSvetla;
  N.parametry.forEach(par => radky.push({nazev:`${par.nazev} celkem`, popis:`${par.nazev.toLowerCase()} za kus × počet kusů`, vase:zm[par.klic], nase:om[par.klic], jednotka:par.jednotka, lepsi:par.lepsi, des:par.des,
    dostatecne: par.klic === klicSvetla && podleSpec && om[par.klic] < zm[par.klic]}));
  (N.odvozene||[]).forEach(d => radky.push({nazev:d.nazev, popis:d.popis, vase:zm[d.citatel]/zm[d.jmenovatel]*d.nasobek, nase:om[d.citatel]/om[d.jmenovatel]*d.nasobek, jednotka:d.jednotka, lepsi:d.lepsi, des:d.des}));
  (N.vlastnosti||[]).forEach(v => radky.push({nazev:v.nazev, popis:"", vase:z[v.klic], nase:hodnota((prod.vlastnosti||{})[v.klic]), jednotka:v.jednotka, lepsi:v.lepsi, des:v.des}));
  $("tabulka").innerHTML = radky.map(r => {
    const rz = r.dostatecne ? {txt:"dostatečné", cls:"nula", lepsiNase:null} : rozdil(r.nase, r.vase, r.lepsi);
    return `<tr><td class="nazev">${r.nazev}${r.popis?`<small>${r.popis}</small>`:""}</td>
      <td class="hodnota ${rz.lepsiNase===false?"vitez":""}">${fmt(r.vase,r.des)} ${r.jednotka}</td>
      <td class="hodnota ${rz.lepsiNase?"vitez":""}">${Number.isFinite(r.nase) ? fmt(r.nase,r.des)+" "+r.jednotka : '<span class="chybi">doplníme</span>'}</td>
      <td><span class="rozdil ${rz.cls}">${rz.txt}</span></td></tr>`;
  }).join("");

  /* verdikt */
  const pr = N.provoz || {};
  const kc = pr.klicCeny, lm = pr.klicSvetla, w = pr.klicPrikonu;
  const uspora = zm[kc] - om[kc];
  const svetloPct = (om[lm] - zm[lm]) / zm[lm] * 100;
  const prikonPct = (om[w] - zm[w]) / zm[w] * 100;
  const svetlo = !Number.isFinite(svetloPct) ? "" : svetloPct >= 0.5 ? `a dostanete o ${fmt(svetloPct)} % víc světla` : podleSpec ? `při rozmístění podle specifikace pro rovnoměrné prozáření boxu` : "";
  let text;
  if(!Number.isFinite(zm[kc]) || !Number.isFinite(zm[lm])) text = "Doplňte všechna čísla vlevo a výsledek se ukáže tady.";
  else if(!Number.isFinite(om[kc])) text = `Cenu této varianty doplníme - pošleme vám ji na vyžádání.`;
  else text = (uspora >= 0 ? `S <strong>${prod.nazev}</strong> ušetříte <strong class="akcent">${fmt(uspora)} Kč</strong> na každém ${N.jednotkaPlochy}` : `<strong>${prod.nazev}</strong> vyjde o <strong class="akcent">${fmt(-uspora)} Kč</strong> na ${N.jednotkaPlochy} dráž`) + (svetlo ? ` ${svetlo}.` : ".");
  $("verdiktText").innerHTML = text;
  const zp = $("zarukaPas");
  if(Number.isFinite(zarN)){
    const zz = z.zaruka, navic = Number.isFinite(zz) ? zarN - zz : NaN;
    zp.innerHTML = `${stit.replace('width="26" height="26"','width="40" height="40"')}<span class="velke">${roky(zarN)}</span>
      <span class="text"><b>záruka na ${prod.nazev}</b><span style="opacity:.75">${Number.isFinite(zz) ? `${VN}: ${roky(zz)}` : "Doplňte vlevo záruku vašich LED"}</span></span>
      ${Number.isFinite(navic) && navic > 0 ? `<span class="rozdil-z">o ${roky(navic)} déle</span>` : ""}`;
    zp.hidden = false;
  } else zp.hidden = true;

  const hl = $("v_hloubka").value;
  $("verdiktCisla").innerHTML = [
    [`${fmt(zm[kc])} → ${fmt(om[kc])} Kč`, `cena za 1 ${N.jednotkaPlochy}`],
    [`${fmt(om[lm])} lm`, podleSpec ? `světlo na 1 ${N.jednotkaPlochy} - dostatečné pro box ${fmt(num(hl))} ${N.volba.jednotka}` : `světlo na 1 ${N.jednotkaPlochy}`],
    [`${fmt(zm[w],1)} → ${fmt(om[w],1)} W`, `příkon na 1 ${N.jednotkaPlochy}${Number.isFinite(prikonPct)&&Math.abs(prikonPct)>=0.5?` (${prikonPct<0?"−":"+"}${fmt(Math.abs(prikonPct))} %)`:""}`],
    [Number.isFinite(uspora) ? `${uspora >= 0 ? "" : "+"}${fmt(Math.abs(uspora))} Kč` : "-", uspora >= 0 ? `úspora na každém ${N.jednotkaPlochy}` : `navíc na každém ${N.jednotkaPlochy}`]
  ].map(([b,s],i) => `<div class="cislo${i===3?" uspora":""}"><b>${b}</b><small>${s}</small></div>`).join("");

  kresliSloupce(S, zm, h, prod, VN, z.zaruka, zarN);

  $("rozmerNadpis").textContent = Number.isFinite(A) ? `Výsledek pro ${fmt(A,2)} m²` : "Výsledek pro váš rozměr";
  $("rozmerPopis").textContent = Number.isFinite(A) ? `${fmt(rPocet)} × rám ${fmt(rSirka)} × ${fmt(rVyska)} mm` : "Vyplňte rozměr rámu nahoře.";

  /* výsledek pro zadaný rozměr */
  if(N.provoz){
    const zNakup = zm[kc]*A, oNakup = om[kc]*A;
    const zKs = Math.ceil(z.ks*A), oKs = Math.ceil(om.ks*A);
    const dl = (nadpis, vase, nase, jedn, des, vysl) => `<div class="dlazdice"><span class="popisek">${nadpis}</span>
      <div class="radek"><span>${VN}</span><b>${fmt(vase,des)} ${jedn}</b></div>
      <div class="radek nase"><span>${prod.nazev}</span><b>${fmt(nase,des)} ${jedn}</b></div>
      <div class="vysledek">${vysl}</div></div>`;
    const st = stupne(prod)[bal] || {};
    S.posledniVysledek = {
      nazevLed: ($("z_nazev")?.value || "").trim(), pouziti: (N.kryti||[]).find(k => k.hodnota === $("z_kryti")?.value)?.nazev || "",
      hloubka: num(h),
      zakaznik: { ks: z.ks, cena: z.cena, lm: z.lm, w: z.w, zaruka: z.zaruka },
      lightwell: { produkt: prod.nazev, nakupKs: st.ks ?? null, cenaKs: o[kc], ksM2: om.ks },
      vysledek: { vaseCenaM2: zm[kc], naseCenaM2: om[kc], usporaM2: zm[kc]-om[kc], plocha: A, usporaProjekt: zNakup-oNakup }
    };
    $("souhrn").innerHTML =
      dl("Nákup LED", zNakup, oNakup, "Kč", 0, !Number.isFinite(zNakup-oNakup) ? "-" : zNakup-oNakup >= 0 ? `Ušetříte ${fmt(zNakup-oNakup)} Kč` : `O ${fmt(oNakup-zNakup)} Kč víc`) +
      dl("Počet kusů", zKs, oKs, N.kus, 0, !Number.isFinite(zKs-oKs) ? "-" : zKs-oKs >= 0 ? `O ${fmt(zKs-oKs)} ${N.kus} méně k montáži` : `O ${fmt(oKs-zKs)} ${N.kus} víc k montáži`);
  }
}

/* ===== graf: cena za 1 m² ve sloupcích - vaše LED proti vybrané variantě po stupních nákupu ===== */
const zarIkona = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5l-8-3Z"/></svg>`;
function kresliSloupce(S, zm, h, prod, VN, zarZak, zarNase){
  const { N, $, fmt, num, hodnota, naM2, zvolenyStupen, stupne, roky } = S;
  const kc = (N.provoz||{}).klicCeny || "cena";
  const par = N.parametry.find(x => x.klic === kc) || N.parametry[0];
  const vyb = zvolenyStupen();
  const rady = [{nazev:VN, v:zm[kc], barva:"var(--g-vase)", vybrany:false, vase:true, zaruka:zarZak}];
  stupne(prod).forEach((t,i) => i === vyb && rady.push({
    nazev: `${prod.nazev}${prod.venkovni ? " · <b>OUTDOOR</b>" : ""}<br>${fmt(hodnota(t.cena))} Kč/${N.kus}`,
    v: Number.isFinite(hodnota(t.cena)) ? naM2(prod, h, i)?.[kc] : NaN,
    barva: i === vyb ? "var(--g-nase)" : "var(--g-dalsi)", vybrany: i === vyb, zaruka:zarNase }));
  $("legendaSloupce").innerHTML = `<span><i style="background:var(--g-vase)"></i>${VN}</span><span><i style="background:var(--g-nase)"></i>${prod.nazev}${prod.venkovni ? " · OUTDOOR" : ""}</span><span class="maly">hloubka ${fmt(num(h))} ${N.volba.jednotka} · ${par.nazev.toLowerCase()} za 1 ${N.jednotkaPlochy}, méně je lépe</span>`;
  const max = Math.max(...rady.map(r => r.v).filter(Number.isFinite), 0);
  $("panely").innerHTML = `<div class="sloupce">${rady.map(r => {
      const vyska = Number.isFinite(r.v) && max > 0 ? Math.max(r.v/max*100, 2) : 0;
      const usp = zm[kc] - r.v;
      const stitek = r.vase || !Number.isFinite(usp) || Math.abs(usp) < 0.5 ? "" : `<span class="usp ${usp>0?"plus":"minus"}">${usp>0 ? "−"+fmt(usp) : "+"+fmt(-usp)} Kč</span>`;
      const zarChip = Number.isFinite(hodnota(r.zaruka)) ? `<span class="zar">${zarIkona}${roky(r.zaruka)}</span>` : "";
      return `<div class="sl" title="${r.nazev.replace("<br>"," - ").replace(/<[^>]+>/g,"")}: ${fmt(r.v,par.des)} ${par.jednotka}">
        ${Number.isFinite(r.v) ? `<span class="hodn">${fmt(r.v,par.des)} Kč</span>` : '<span class="chybi">cenu doplníme</span>'}${stitek}${zarChip}
        <div class="tyc" style="height:calc(${vyska}% - 60px);background:${r.barva}"></div></div>`;
    }).join("")}</div>
    <div class="popisky">${rady.map(r => `<div class="${r.vybrany?"vybrany":""}">${r.nazev}</div>`).join("")}</div>`;
}
